import { createReducer, on } from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';
import { TokenModel } from '../../../model/token.model';

export const authFeatureKey = 'auth';

export interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  token: TokenModel | null;
}

export const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: true, // Start true for initial auth
  token: null,
};

export const authReducer = createReducer(
  initialState,
  on(AuthActions.checkAuth, (state): AuthState => ({ ...state, isLoading: true })),
  on(
    AuthActions.checkAuthSuccess,
    (state, { token }): AuthState => ({
      ...state,
      isLoading: false,
      isAuthenticated: true,
      token,
    }),
  ),
  on(
    AuthActions.tokenRefreshed,
    (state, { token }): AuthState => ({
      ...state,
      token, // Update token while preserving auth state
    }),
  ),
  on(
    AuthActions.checkAuthFailure,
    AuthActions.logoutSuccess,
    AuthActions.forceLogout,
    (): AuthState => ({
      ...initialState,
      isLoading: false,
    }),
  ),
);
